module.exports = __webpack_public_path__ + "img/operation1.52792375.png";